import Excel from 'exceljs'
import ExportExpenditure from "@/types/expenditure/exportExpenditure"
import ExportTracking from "@/types/tracking/exportTracking"

export function exportEntries
(
  timesHeaders: any,
  expenditureHeaders: any,
  trackingEntries: ExportTracking[],
  expenditureEntries: ExportExpenditure[],
  filename: string,
  timetrackWorksheetName: string,
  expenditureWorksheetName: string
) {
  const workbook = new Excel.Workbook()
  const timetrackEntriesWorksheet = workbook.addWorksheet(timetrackWorksheetName)
  const expenditureEntriesWorksheet = workbook.addWorksheet(expenditureWorksheetName)
  const trackingEndRow = trackingEntries.length + 2
  const expenditureEndRow = expenditureEntries.length + 2
  timetrackEntriesWorksheet.columns = timesHeaders
  trackingEntries.forEach((item) => {
    timetrackEntriesWorksheet.addRow(item)
  })
  expenditureEntriesWorksheet.columns = expenditureHeaders
  expenditureEntries.forEach((item) => {
    expenditureEntriesWorksheet.addRow(item)
  })

  expenditureEntriesWorksheet.getColumn(4).numFmt = '#,##0.00 [$€-1];[Red]-#,##0.00 [$€-1]'
  expenditureEntriesWorksheet.getColumn(5).numFmt = '#,##0.00 [$€-1];[Red]-#,##0.00 [$€-1]'
  timetrackEntriesWorksheet.getColumn(7).numFmt = '#,##0.00 [$€-1];[Red]-#,##0.00 [$€-1]'

  timetrackEntriesWorksheet.getCell(`G${trackingEndRow}`).value = { formula: `SUM(G2:G${trackingEndRow - 1})`, date1904: false }
  timetrackEntriesWorksheet.getCell(`F${trackingEndRow}`).value = { formula: `SUM(F2:F${trackingEndRow - 1})`, date1904: false }
  expenditureEntriesWorksheet.getCell(`E${expenditureEndRow}`).value = { formula: `SUM(E2:E${expenditureEndRow - 1})`, date1904: false }

  downloadXLSX(workbook, filename)
}

function downloadXLSX (workbook: any, filename: string) {
  workbook.xlsx.writeBuffer().then((data: any) => {
    const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, filename)
    } else {
      const link = document.createElement('a')
      if (link.download !== undefined) {
        // Browsers that support HTML5 download attribute
        const url = URL.createObjectURL(blob)
        link.setAttribute('href', url)
        link.setAttribute('download', filename)
        link.style.visibility = 'hidden'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    }
  })
}
